/**
 * Created by alex on 11-7-2017.
 */

import { Injectable }          from '@angular/core';
import { CsDataGridComponent } from '../data-grid.component';
import { Subject }             from 'rxjs';

@Injectable()
export class DataGridMessageHubService {

	runChangeDetection: Subject<string> = new Subject();

	readonly allRegisteredNestedGrid: Array<CsDataGridComponent> = [];

	constructor() {
	}


	register(dataGrid: CsDataGridComponent) {
		this.allRegisteredNestedGrid.push(dataGrid);
	}

	unregister(dataGrid: CsDataGridComponent) {
		const foundIndex = this.allRegisteredNestedGrid.findIndex(grid => grid.id === dataGrid.id);
		this.allRegisteredNestedGrid.splice(foundIndex, 1);
	}

}
